export const scale=[
    {
        key:'graph:time',
        value:'TIME',
    },
    {
        key:'graph:distance',
        value:'DISTANCE',
    }
]